import axios from "axios";
import * as ActionType from "./admin.type";
import { setToast } from "../../util/toast";
import { apiInstanceFetch } from "../../util/api";

export const signupAdmin = (signup) => (dispatch) => {
  console.log("createAdmin", signup);
  axios
    .post("admin/admin/create", signup)
    .then((res) => {
      console.log(res);
      if (res.data.status) {
        dispatch({ type: ActionType.SIGNUP_ADMIN });
        setToast("success", "Signup Successfully!");
        setTimeout(() => {
          window.location.href = "/login";
        }, 100);
      } else {
        setToast("error", res.data.message);
      }
    })
    .catch((error) => {
      setToast("error", error);
      console.log(error);
    });
};

export const updateCode = (signup) => (dispatch) => {
  axios
    .patch("admin/admin/updateCode", signup)
    .then((res) => {
      console.log(res);
      if (res.data.status) {
        setToast("success", "Purchase Code Update Successfully !");
        setTimeout(() => {
          window.location.href = "/login";
        }, 100);
      } else {
        setToast("error", res.data.message);
      }
    })
    .catch((error) => {
      setToast("error", error);
      console.log(error);
    });
};

export const loginAdmin = (login) => (dispatch) => {
  axios
    .post("admin/admin/login", login)
    .then((res) => {
      if (res.data.status) {
        {
          res?.data?.admin?._id === "6697b01f9c1b74e81221ff7a"
            ? (window.location.href = "/admin/mainDashboard")
            : (window.location.href = "/admin/subdashboard");
        }
        dispatch({ type: ActionType.LOGIN_ADMIN, payload: res.data.token });
        setToast("success", "Login Successfully!");
      } else {
        setToast("error", res.data.message);
      }
    })
    .catch((error) => {
      setToast("error", error.response.data.message);
    });
};

export const changePassword = (data) => (dispatch) => {
  axios
    .patch(`admin/admin/updatePassword`, data)
    .then((res) => {
      if (res.data.status) {
        setToast("success", "Password Changed Successfully.");
        setTimeout(() => {
          dispatch({ type: ActionType.UNSET_ADMIN });
          window.location.href = "/login";
        }, [3000]);
      } else {
        setToast("error", res.data.message);
      }
    })
    .catch((error) => setToast("error", error.message));
};

export const getAdminEarnings =
  (startDate, endDate, start, limit) => (dispatch) => {
    apiInstanceFetch
      .get(
        `admin/premiumPlan/getpremiumPlanHistory?startDate=${startDate}&endDate=${endDate}&start=${start}&limit=${limit}`,
      )
      .then((res) => {
        if (res.status) {
          dispatch({
            type: ActionType.ADMIN_EARNING,
            payload: {
              earning: res.history,
              total: res.totalHistory,
              totalEarning: res.totalAdminEarnings,
            },
          });
        }
      });
  };
